export type GridView = {
  id: string;
  rules: string;
  name: string;
  slug: string | null;
  imageUrl: string | null;
  description: string | null;
  onlyMarketFiltered: boolean | null;
  crawlable: boolean;
  typeSlug: string;
  modifyDate: number | null;
};

export const getQueryKey = <T>(id: T extends string ? T : never) =>
  [`GRID_VIEW_${id}`] as const;

export const getDefault = (): GridView => ({
  id: '0',
  rules: '',
  slug: '',
  name: '',
  description: '',
  onlyMarketFiltered: true,
  crawlable: false,
  imageUrl: null,
  typeSlug: 'discover-page-v1',
  modifyDate: null,
});
